import { useState, useCallback } from 'react';
import { useToast } from './useToast';
import { needsApi } from '../services/api';

export const useWorkflowTrigger = (need, onNeedUpdate) => {
  const [loadingStates, setLoadingStates] = useState({});
  const { showToast } = useToast();

  const setLoading = useCallback((operation, loading) => {
    setLoadingStates(prev => ({ ...prev, [operation]: loading }));
  }, []);

  const triggerWorkflow = useCallback(async (operation) => {
    if (!need?.id) return;

    setLoading(operation, true);
    try {
      showToast(`${operation} workflow started`, 'info');

      setTimeout(async () => {
        try {
          const updatedNeed = await needsApi.getNeed(need.id);
          onNeedUpdate?.(updatedNeed);
          showToast(`${operation} completed successfully`, 'success');
        } catch (error) {
          showToast(`${operation} may have failed`, 'warning');
        }
        setLoading(operation, false);
      }, 5000);

    } catch (error) {
      showToast(`Failed to start ${operation}: ${error.message}`, 'error');
      setLoading(operation, false);
    }
  }, [need, onNeedUpdate, showToast, setLoading]);

  return {
    triggerWorkflow,
    loadingStates,
    isLoading: (operation) => !!loadingStates[operation]
  };
};
